type ReplaceLineBreak = (string: string, replaceWith: string) => string

export const replaceLineBreak: ReplaceLineBreak = (
  string,
  replaceWith = "<br/>"
) => {
  return string && string.split("\n").join(replaceWith)
}
